import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { STOCKITEMS_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  currentPayslips: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const useCurrentPayrunListFetch = () => {
  const auth = useAuth();
  const [currentPayrunliststate, setcurrentPayrunlistState] = useState(initialState);
  const [currentPayrunlistsearchValue, currentPayrunlistSetSearchValue] = useState("");
  const [currentPayrunListincludeInactive, setcurrentPayrunlistIncludeInactive] = useState(false);
  const [currentPayrunlisttrigger, setcurrentPayrunlistTrigger] = useState(false);
  const [currentPayrunlistloading, setcurrentPayrunlistLoading] = useState(false);
  const [currentPayrunlisterror, setcurrentPayrunlistError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true); // ✅ Prevent double fetching

  const accessToken = auth.auth.accessToken;

  const fetchCurrentPayrunlists = async (page, searchValue, reset = false) => {
    if (!hasMore && !reset) return; // Stop fetching if no more pages

    try {
      setcurrentPayrunlistLoading(true);
      setcurrentPayrunlistError(false);

      console.log(reset)

      const data = await API.fetchCurrentPayrunlists(searchValue, page, currentPayrunListincludeInactive, "", accessToken);
        
      console.log(data)
      setcurrentPayrunlistState((prev) => ({
        ...prev,
        currentPayslips: reset ? data.currentPayslips : data.currentPayslips, // ✅ Only reset on filter/search change
        page: page + 1,
        total_pages: data.total_pages,
        total_results: data.total_results,
      }));

      setHasMore(data.currentPayrunlist.length > 0);
      setcurrentPayrunlistLoading(false);
     
    } catch (error) {
      console.error("Error fetching stock items:", error);
      setcurrentPayrunlistError(true);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchCurrentPayrunlists(1, currentPayrunlistsearchValue, true);
    }
  }, [firstLoad]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    fetchCurrentPayrunlists(1, currentPayrunlistsearchValue, true); // ✅ Fetch when search/filter changes
  }, [currentPayrunlistsearchValue, currentPayrunListincludeInactive,currentPayrunlisttrigger]);

  return { currentPayrunliststate, currentPayrunlistloading, currentPayrunlisterror,currentPayrunlisttrigger,currentPayrunlistsearchValue, currentPayrunlistSetSearchValue, setcurrentPayrunlistIncludeInactive, fetchCurrentPayrunlists,setcurrentPayrunlistTrigger };
};
